import { authorizedFetch as fetch } from '@/helpers/authFetch';
import { checkServiceOK } from '@/services/serviceConstants';

const checkedFetch = async (url, defaultValue, options = {}) => {
  try {
    const response = await fetch(url, options);

    return await checkServiceOK(response);
  } catch (err) {
    return defaultValue;
  }
};

export const checkedTextFetch = async (url, defaultValue, options = {}) => {
  try {
    const response = await fetch(url, options);

    return checkServiceOK(response, true);
  } catch (err) {
    return defaultValue;
  }
};

export default checkedFetch;
